export const HEIGHT_PER_DAY = 120;

export enum WEATHER_STATUS {
    BAD,
    MODERATE,
    GOOD
}

export const weatherStatus: any = {
    [WEATHER_STATUS.BAD]: { id: WEATHER_STATUS.BAD, name: 'Bad weather' },
    [WEATHER_STATUS.MODERATE]: { id: WEATHER_STATUS.MODERATE, name: 'Moderate weather' },
    [WEATHER_STATUS.GOOD]: { id: WEATHER_STATUS.GOOD, name: 'Good weather' }
};
